import React, { Component } from 'react';
import { source } from 'react-aim';
import { dispatch } from '@rematch/core';
import { Button, Icon, Label } from "semantic-ui-react";
import Accordion from '@zippytech/react-toolkit/Accordion';
import '@zippytech/react-toolkit/Accordion/index.css';

import Summary from './PublishPlaybook/Summary'
import Detail from './PublishPlaybook/Detail'

@source({
    mouseEnter: (props, component) => dispatch.app.setHelpContext("Resource Pane")
})
class PublishPlaybookResourcePane extends Component {



    next() {
        //this.props.setCollapsedResourcePaneIndex(null);
        dispatch.app.setCollapsedResourcePaneIndexTemp(null)
        dispatch.initiatives.showResourecePane(null);
        dispatch.initiatives.setTeamList([])
        const history = this.props.history;
        history.push({
            pathname: '/app/' + this.props.match.params.accountId + '/_ws/' + this.props.match.params.workspaceId + '/_in/indesign/basicInfo'
        });
    }

    render() {
        let data = {}
        if (this.props.selectedDataById && this.props.selectedDataById._id) {
            data = this.props.selectedDataById
        } else {
            data = this.props.selectedPlaybookData
        }
        const expandTool = <div className="plusMinusIcons"  >
            <Icon className="close" name="plus circle" />
            <Icon className="open" name="minus circle" />
        </div>

        return (
            <div className="accordianBox w_100">
                <div className="accordianPanel w_90">



                    <Accordion expandTool={expandTool} horizontal className="practiceFlowResourcePane" enableKeyboardNavigation={false}>
                        {[
                            <div tabTitle="Summary">
                                <div className="acc-header">Summary</div>
                                <Detail selectedDataById={data} playbookOwnerDetails={this.props.playbookOwnerDetails} />
                            </div>,
                            <div tabProps={{ title: 'Details' }}>
                                <div className="acc-header">Details</div>
                                <Summary selectedDataById={data} />
                            </div>
                        ].filter(elem => !!elem)}
                    </Accordion>
                </div>
                <div className="accordianSideBox w_10">
                    <div className="buttonSet ">
                        <div >
                            <Button id='next' className="button-submit"style={{padding:"10px"}} onClick={() => this.next()} disabled={this.props.selectedPlaybookData.createInitiative==false}> Select </Button>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}


export default PublishPlaybookResourcePane;

